'use client';
import { Button } from '@vs-shop/ui/button';
import { shouldAddToCartButtonBeDisabled } from '../../../../shared/utils/stockValidation';

import { IconCartOutline } from '@vs-shop/ui/icons';

import type { AddProductVariantToOrderDataProduct } from '../../../../effect/flow/order/addProductVariantToOrder';
import { useAddToCart, useVariantInCart } from '../../../../hook/useAddToCart';
import { useCartLinePreviewPreload, withCartLinePreview } from '../../../../hook/cartLinePreview';
import type { ProductAgeRestriction } from '@vs-shop/schemas/branded/ProductSchema';
import type { ProductImagePreview } from '../../../../product/productImagePreview';

type Props = {
  product: AddProductVariantToOrderDataProduct;
  buttonText: string;
  imagePreview: ProductImagePreview;
  ageRestriction: ProductAgeRestriction;
};

export default function ContentBlockButtonAddToCartButton({
  product,
  buttonText,
  imagePreview,
  ageRestriction,
}: Props) {
  const addToCart = useAddToCart();
  const { quantityInCart, isAdding } = useVariantInCart(product.code);
  const imagePath = imagePreview.kind === 'available' ? imagePreview.template : null;
  const cartRequest = withCartLinePreview({ product, quantity: 1 }, imagePath, ageRestriction);
  const preloadHandlers = useCartLinePreviewPreload([cartRequest.preview]);

  const isDisabled =
    isAdding ||
    shouldAddToCartButtonBeDisabled(
      product.stock.eshop.maxOrderable,
      quantityInCart,
      1,
      product.priceWithoutTax
    );

  return (
    <div className="relative w-full tab:w-auto">
      <Button
        {...preloadHandlers}
        onClick={() => {
          addToCart([cartRequest]);
        }}
        loading={isAdding}
        disabled={isDisabled}
        variant="primary"
        size="block2xl"
      >
        <IconCartOutline className="size-5 shrink-0 tab:size-6" />
        {buttonText}
      </Button>
    </div>
  );
}
